import FeatureFlagManager from './FeatureFlagManager.js';
import SessionManager from './SessionManager.js';
import PermissionManager from './PermissionManager.js';
import PreferencesManager from './PreferencesManager.js';
import * as errors from './lib/errors.js';
/**
 * Configure the package and related resources for the applicable
 * environment. Defines the appropriate URLs for API interactions.
 * @param {object} environment
 * @param {string} environment.domain
 * @param {string} environment.protocol
 */
export function configure({ domain, protocol, ...env } = { domain: 'mysw.com', protocol: 'http' }) {
    FeatureFlagManager.configure(env);
    const connection = { domain, protocol };
    SessionManager.configure(connection);
    PermissionManager.configure(connection);
    PreferencesManager.configure(connection);
}
export { FeatureFlagManager, SessionManager, PermissionManager, PreferencesManager, errors, };
const index = {
    configure,
    FeatureFlagManager,
    SessionManager,
    PermissionManager,
    PreferencesManager,
};
export default index;
